/* Maison Oria – site officiel. No dependencies. */
(function () {
  'use strict';
  var root = document.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. reveal on scroll */
  function initReveal(scope) {
    var els = (scope || document).querySelectorAll('.o-rv:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* 2. countdown: [data-o-countdown data-launch="ISO"] with [data-cd=d|h|m|s] inside */
  function pad(n) { return n < 10 ? '0' + n : String(n); }
  function initCountdowns(scope) {
    (scope || document).querySelectorAll('[data-o-countdown]').forEach(function (box) {
      if (box.dataset.ready) return;
      box.dataset.ready = '1';
      var t = Date.parse(box.dataset.launch);
      if (isNaN(t)) return;
      var wrap = box.closest('[data-o-launch-scope]') || box.parentNode;
      var cells = {};
      ['d', 'h', 'm', 's'].forEach(function (k) { cells[k] = box.querySelector('[data-cd="' + k + '"]'); });
      function set(k, v) {
        var el = cells[k];
        if (!el || el.textContent === v) return;
        el.textContent = v;
        if (!reduce) { el.classList.add('is-tick'); setTimeout(function () { el.classList.remove('is-tick'); }, 220); }
      }
      function done() {
        wrap.querySelectorAll('[data-o-before]').forEach(function (el) { el.hidden = true; });
        wrap.querySelectorAll('[data-o-after]').forEach(function (el) { el.hidden = false; });
      }
      function tick() {
        var diff = t - Date.now();
        if (diff <= 0) { done(); return false; }
        var s = Math.floor(diff / 1000);
        set('d', String(Math.floor(s / 86400)));
        set('h', pad(Math.floor(s % 86400 / 3600)));
        set('m', pad(Math.floor(s % 3600 / 60)));
        set('s', pad(s % 60));
        return true;
      }
      if (tick()) { var id = setInterval(function () { if (!tick()) clearInterval(id); }, 1000); }
    });
  }

  /* 3. signup forms: size choice becomes a customer tag, and no double sending */
  function initForms(scope) {
    (scope || document).querySelectorAll('form').forEach(function (form) {
      if (form.dataset.oReady) return;
      var tags = form.querySelector('[data-o-tags]');
      if (!tags && !form.classList.contains('o-signup') && !form.hasAttribute('data-o-buy')) return;
      form.dataset.oReady = '1';
      if (tags) {
        var base = tags.dataset.base || tags.value;
        var sync = function () {
          var picked = form.querySelector('input[name="o_taille"]:checked');
          tags.value = picked ? base + ', taille-' + picked.value : base;
        };
        form.addEventListener('change', sync);
        sync();
      }
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[type="submit"]');
        if (btn) { setTimeout(function () { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }, 0); }
      });
    });
  }

  /* 4. product gallery: hover zoom that follows the cursor, click opens a large view, dots on mobile */
  function initGallery(scope) {
    (scope || document).querySelectorAll('[data-o-gallery]').forEach(function (gal) {
      if (gal.dataset.ready) return;
      gal.dataset.ready = '1';
      var items = gal.querySelectorAll('.o-gal__item');
      items.forEach(function (item) {
        var media = item.querySelector('img, svg');
        if (!media) return;
        item.addEventListener('mousemove', function (e) {
          var r = item.getBoundingClientRect();
          media.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        item.addEventListener('mouseleave', function () { media.style.transformOrigin = ''; });
      });
      var zoom = document.getElementById(gal.dataset.oGallery);
      if (zoom) {
        var slot = zoom.querySelector('[data-o-zoom-slot]');
        gal.querySelectorAll('[data-o-zoom]').forEach(function (btn) {
          btn.addEventListener('click', function () {
            var src = btn.parentNode.querySelector('img, svg');
            if (!src || !slot) return;
            slot.innerHTML = '';
            var copy = src.cloneNode(true);
            copy.removeAttribute('style');
            if (copy.tagName.toLowerCase() === 'img' && btn.dataset.full) { copy.src = btn.dataset.full; copy.removeAttribute('srcset'); copy.removeAttribute('sizes'); }
            slot.appendChild(copy);
            openDialog(zoom);
          });
        });
      }
      var dots = gal.parentNode.querySelectorAll('.o-gal__dots span');
      if (dots.length) {
        gal.addEventListener('scroll', function () {
          var i = Math.round(gal.scrollLeft / gal.clientWidth);
          dots.forEach(function (d, j) { d.classList.toggle('is-on', i === j); });
        }, { passive: true });
      }
    });
  }

  /* 5. dialogs (size guide, zoom) */
  function openDialog(d) {
    if (!d) return;
    if (typeof d.showModal === 'function') { d.showModal(); } else { d.setAttribute('open', ''); }
  }
  function initDialogs(scope) {
    (scope || document).querySelectorAll('[data-o-open]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () { openDialog(document.getElementById(btn.dataset.oOpen)); });
    });
    (scope || document).querySelectorAll('dialog.o-dialog').forEach(function (d) {
      if (d.dataset.ready) return;
      d.dataset.ready = '1';
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.closest('[data-o-close]')) { d.close ? d.close() : d.removeAttribute('open'); }
      });
    });
  }

  function init(scope) {
    window.OriaReady = true;
    root.classList.add('o-js');
    initReveal(scope); initCountdowns(scope); initForms(scope); initGallery(scope); initDialogs(scope);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { init(); }); } else { init(); }
  /* theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();